export default {
  // Member Management
  'member.memberId': 'Member ID',
  'member.enterMemberId': 'Please enter member ID',
  'member.phone': 'Phone',
  'member.email': 'Email',
  'member.accountStatus': 'Account Status',
  'member.signUpStatus': 'Sign Up Status',
  'member.notSignUp': 'Not Signed Up',
  'member.inCompetition': 'In Competition',
  'member.inSignUp': 'Signing Up',
  'member.totalInvite': 'Total Invite',
  'member.usedTickets': 'Used Tickets',
  'member.remainTickets': 'Remain Tickets',
  'member.balance': 'Balance',
  'member.totalBonus': 'Total Bonus',
  'member.totalExchange': 'Total Exchange',
  'member.totalWithdraw': 'Total Withdraw',
  'member.inviteCode': 'Invite Code',
  'member.enterInviteCode': 'Please enter invite code',
  'member.parentId': 'Parent ID',
  'member.enterParentId': 'Please enter parent ID',
  'member.createTime': 'Register Time',
  'member.lastLoginTime': 'Last Login Time',
  'member.balanceFilter': 'Balance',
  'member.hasBalance': 'Has Balance',
  'member.noBalance': 'No Balance',
  'member.enterPhone': 'Please enter phone',
  'member.enterEmail': 'Please enter email',
  'member.password': 'Password',
  'member.enterPassword': 'Please enter password',
  'member.memberInfo': 'Member Info',
  'member.withdrawStatus': 'Withdraw Status',
  'member.username': 'Username',
  'member.disableTooltip': 'Disabled: cannot login, sign up, withdraw',
  'member.getListFailed': 'Failed to get member list',
  'member.exportFileName': 'Member list-{date}.csv',
  'member.userId': 'User ID',

  'member.passwordMin8': 'Password must be at least 8 characters',
  'member.invalidPhone': 'Please enter a 9-starting 10-digit phone number',
  'member.invalidPhone243': 'Please enter a 10-digit phone number',
  'member.usernameRegex':
    'Username must be 8-20 characters long, containing only letters and numbers, and cannot contain symbols',
  'member.withdrawSum': 'Withdraw Times',

  'member.levelName': 'Level Name',
  'member.peopleCount': 'People Count',
  'member.singleWithdrawAmount': 'Single Withdraw Amount',
  'member.permissions': 'Permissions',
  'member.operationTime': 'Operation Time',
  'member.withdrawal': 'Withdrawal',
  'member.invitationRewards': 'Invite Rewards',
  'member.dailyWithdrawApplyLimit': 'Daily Withdrawal Application Limit',
  'member.min': 'Minimum',
  'member.max': 'Maximum',
  'member.cumulativeSuccessWithdrawLimit': 'Cumulative Success Withdrawal Limit',
  'member.daily': 'Daily',
  'member.weekly': 'Weekly',
  'member.monthly': 'Monthly',
  'member.times': 'Times',

  'member.accountId': 'Account ID',
  'member.ip': 'IP',
  'member.deviceType': 'Device Type',
  'member.iosH5': 'iOS H5',
  'member.androidH5': 'Android H5',
  'member.macPc': 'Mac PC',
  'member.windowsPc': 'Windows PC',
  'member.other': 'Other',
  'member.deviceCode': 'Device Code',
  'member.address': 'Address',
  'member.operationType': 'Operation Type',
  'member.register': 'Register',
  'member.login': 'Login',
  'member.loginTime': 'Login Time',
  'member.loginLogExportFileName': 'Login Log Query-{date}.csv',
  'member.hierarchyLevelId': 'Hierarchy Level ID',
  'member.registerSource': 'Register Source',
  'member.registerSourceSelf': 'Self',
  'member.registerDomain': 'Register Domain',
  'member.channelId': 'Channel ID',
  'member.channelName': 'Channel Name',
  'member.parentStatus': 'Parent',
  'member.subordinateStatus': 'Subordinate',
  'member.relationHas': 'Has',
  'member.relationNone': 'None',
  'member.kycStatus': 'KYC',
  'member.kycVerified': 'Verified',
  'member.kycUnverified': 'Unverified',
  'member.riskLabel': 'Risk Label',

  // SMS / Verification Code
  'member.smsSendTime': 'Send Time',
  'member.smsStatus': 'Send Status',
  'member.smsNumber': 'Number',
  'member.smsCode': 'Verification Code',
  'member.smsViewerRecord': 'Viewer & Time',
  'member.smsTypePhone': 'Phone',
  'member.smsSendSuccess': 'Send Success',
  'member.smsSendFail': 'Send Failed',
  'member.smsVerifySuccess': 'Verify Success',
  'member.smsVerifyFail': 'Verify Failed',
  'member.smsCodeTitle': 'Verification Code: {code}',
  'member.smsExportFileName': 'Verification Code Records-{date}.csv',

  'invitation.details': 'Invitation Details',
  'member.batchOperations': 'Batch Operations',
  'member.accountIds': 'Account IDs',
  'member.inputMultipleAccountIdsPlaceholder':
    'Enter multiple account IDs, separated by new lines, commas, or spaces, up to 1000 account IDs',
  'member.pleaseInputAccountIds': 'Please enter account IDs',
  'member.maxInputLimitExceeded':
    'You can only enter up to 1000 account IDs, currently entered {current}',
  'member.maxUserIdLengthExceeded': 'Account ID can be at most {max} digits, please check: {id}',
  'member.hierarchy': 'Hierarchy',
  'member.pleaseSelectHierarchy': 'Please select a hierarchy',

  'member.withdrawalStatus': 'Withdrawal Status',

  'member.pleaseInputRemark': 'Please enter remark',

  // KYC
  'member.kycSubmitTime': 'Submit Time',
  'member.kycName': 'Name',
  'member.kycCertType': 'ID Type',
  'member.kycCertNo': 'ID Number',
  'member.kycAuditStatus': 'Audit Status',
  'member.kycRejectReason': 'Reject Reason',
  'member.kycAuditorTime': 'Auditor & Time',
  'member.kycPending': 'Pending',
  'member.kycPassed': 'Approved',
  'member.kycRejected': 'Rejected',
  'member.kycCertIdCard': 'ID Card',
  'member.kycCertDriverLicense': 'Driver License',
  'member.kycAudit': 'Audit',
  'member.kycCertImages': 'ID Images',
  'member.kycPortrait': 'Portrait Side',
  'member.kycEmblem': 'Emblem Side',
  'member.kycHandheld': 'Handheld Photo',
  'member.kycAuditResult': 'Audit Result',
  'member.kycRejectReasonPlaceholder': 'Reject reason',
  'member.kycRejectReasonRequired': 'Please enter reject reason',
  'member.kycAuditor': 'Auditor',
  'member.kycAuditTime': 'Audit Time',
};
